import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import React from "react";

interface DialogComponentProps {
  isOpen: boolean;
  resolve: any;
  count: number;
  type: "largeData" | "emptyFilter" | "queryError";
}

const DialogComponent = (props: DialogComponentProps) => {
  const { isOpen, resolve, count, type } = props;

  const handleDecision = (decision: boolean) => {
    if (resolve) {
      resolve(decision);
    }
  };

  return (
    <>
      {type === "largeData" && (
        <Dialog
          open={isOpen}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            A large amount of data: {count}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Your browser may have performance issues.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => handleDecision(false)}>Cancel</Button>
            <Button onClick={() => handleDecision(true)} autoFocus>
              Continue anyway!
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {type === "emptyFilter" && (
        <Dialog
          open={isOpen}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            Empty filter.
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
             Select filter
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => handleDecision(false)}>Cancel</Button>
            <Button onClick={() => handleDecision(true)} autoFocus>
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {type === "queryError" && (
        <Dialog
          open={isOpen}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
           Query error
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Try fix your query!
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => handleDecision(true)} autoFocus>
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

export default DialogComponent;
